<template>
  <v-card>
    <v-toolbar dark color="sleep" :dense="dense">
      <v-toolbar-title :class="dense ? 'toolbar-dense': ''"> {{ label }} {{ cohort ? `- ${cohort}` : "" }} </v-toolbar-title>
    </v-toolbar>
    <v-card-text class="text-center">
      <v-avatar v-if="!text" color="secondary" class="white--text" :size="dense ? 30 : 100">
        {{ total }}
      </v-avatar>
      <span class="text-capitalize font-weight-bold" v-else v-html="total"/>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: "MetricCard",
  props: {
    label: {
      type: String,
      required: true,
    },
    cohort: {
      type: String,
      required: false,
    },
    total: {
      type: [String, Number],
      required: true,
    },
    dense: {
      type: Boolean,
      default: false
    },
    text: {
      type: Boolean,
      default: false
    }
  },
};
</script>

<style scoped>
.toolbar-dense {
  font-size:14px !important;
}
</style>
